import AbstractComponent from './AbstractComponent';
import Page from '../Page';

export default class Hero extends AbstractComponent {
  private $content: HTMLElement;

  /**
   * The HTML element of the photos.
   */
  private $photos: HTMLElement;

  private $top: HTMLElement;

  /**
   * Initializes the introduction.
   */
  public initialize(): void {
    this.$content = document.querySelector('.hero__left');
    this.$photos = document.querySelector('.hero__photos');
    this.$top = document.querySelector('.hero .container:not(.is-wide)');

    this.scalePhotos();
  }

  /**
   * Called when the window is resized.
   */
  public onWindowResize(lastSize: { width: number, height: number }): void {
    // If the viewport was already on mobile, and the height is only changed
    // minimally, we shouldn't recalculate the values. This will prevent jumping
    // on some phones.
    if (
      Page.IS_TOUCH_DEVICE
      && Math.abs(window.innerHeight - lastSize.height) < 150
    ) {
      return;
    }

    this.scalePhotos();
  }

  /**
   * Scales the photos to always fit the screen.
   */
  private scalePhotos(): void {
    let scaleFactor = 1;
    let maxWidth = 0;

    if (window.innerWidth >= AbstractComponent.BREAKPOINT_MD) {
      maxWidth = this.$top.getBoundingClientRect().width - this.$content.getBoundingClientRect().width;
    } else {
      maxWidth = this.$top.getBoundingClientRect().width;
    }

    if (904 > maxWidth) {
      scaleFactor = (maxWidth - 128) / 904;
    }

    if (window.innerHeight < 900 && (780 * scaleFactor) > this.$content.clientHeight) {
      scaleFactor = this.$content.clientHeight / 780;
    }

    this.$photos.style.transform = `scale(${scaleFactor})`;

    this.$photos.parentElement.style.height = `${780 * scaleFactor}px`;
    this.$photos.parentElement.style.width = `${904 * scaleFactor}px`;
  }
}
